import { ReceiptModel } from 'api-hooks/receipt';
import React from 'react';

import { FormType } from '../components/form-type';

export default function useGetDefaultValues(receipt?: ReceiptModel) {
  const defaultValues = React.useMemo<FormType>(
    () => ({
      number: receipt?.number,
      customerId: receipt?.customer.id ?? null,
      customerBillingId: receipt?.customerBilling?.id ?? null,
      description: receipt?.description ?? '',
      transactionAt: receipt?.transactionAt ?? new Date(),
      tempTransactionAt: receipt?.transactionAt ?? new Date(),
      needApproval: false,
      receiptDetails: receipt?.receiptDetails
        ? receipt.receiptDetails.map((detail) => ({
            isCheck: true,
            dueDate: detail.sale.dueAt,
            invoiceNumber: detail.sale.invoiceNumber,
            status: detail.sale.status,
            saleId: detail.sale.id,
            saleRefId: detail.sale.refId,
            total: detail.sale.total,
            paidAmount: detail.sale.paidAmount,
            dueAmount: detail.sale.total - detail.sale.paidAmount,
            acl: detail.sale.acl,
          }))
        : [],
      customerBillingOptions: [],
    }),
    [receipt],
  );

  return defaultValues;
}
